import { Typography } from '@mui/material';
import { Box } from '@mui/material';
import { useState } from 'react';
import Button from '@mui/material/Button';
import Modal from './Modal';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';

export const DeleteConfirmer = ({
  style,
  text,
  buttonText,
  title,
  message,
  onDelete,
  isDeleting,
  size = 'xs',
  inputConfirmation,
}: {
  style?: React.CSSProperties;
  isDeleting?: boolean;
  inputConfirmation?: boolean;
  text: string;
  buttonText?: string;
  title: string;
  message: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  onDelete: () => void;
}) => {
  const [inputValue, setInputValue] = useState('');
  const [showInputConfirmation, setShowInputConfirmation] = useState(false);

  const renderInputConfirmation = () => {
    if (!showInputConfirmation) {
      return null;
    }

    return (
      <Modal
        open={showInputConfirmation}
        size={size}
        onClose={() => {
          setShowInputConfirmation(false);
        }}
        data-testid="@delete-confirmer-modal"
        closeLabel="Cancel"
        title={title}
        renderContent={() => (
          <>
            <DialogContentText sx={{ mb: 3 }}>{message}</DialogContentText>
            {inputConfirmation && (
              <Box
                sx={{
                  mt: 2,
                  p: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  backgroundColor: 'background.paper',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    mb: 1,
                    color: 'text.secondary',
                    fontWeight: 'bold',
                  }}
                >
                  Type the word &apos;delete&apos; to confirm
                </Typography>
                <TextField
                  value={inputValue}
                  autoFocus
                  onChange={e => setInputValue(e.target.value)}
                  fullWidth
                  slotProps={{ htmlInput: { 'data-testid': '@delete-confirmer-type' } }}
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': {
                        borderColor: 'error.main',
                      },
                    },
                  }}
                />
              </Box>
            )}
          </>
        )}
        renderActions={() => (
          <>
            <Button
              onClick={() => {
                onDelete();
              }}
              data-testid="@delete-confirmer-delete"
              variant="contained"
              color="error"
              disabled={isDeleting || (inputConfirmation && inputValue !== 'delete')}
            >
              {buttonText || 'Delete'}
            </Button>
          </>
        )}
      />
    );
  };

  return (
    <>
      <span
        style={style}
        onClick={() => {
          setShowInputConfirmation(true);
        }}
      >
        {text}
      </span>
      {renderInputConfirmation()}
    </>
  );
};
